( function( $ ){

    // Menu Tabs
    $( '.menu-tabs a' ).on( 'click', function( e ){
        e.preventDefault();
        let index = $( this ).attr( 'data-index' );
        $( '.menu-tab.active' ).removeClass( 'active' );
        $( this ).addClass( 'active' );
        $( '.tab-block.active' ).removeClass( 'active' );
        $( '.tab-block[data-index="'+ index +'"]' ).addClass( 'active' );
    });

    // Location Map
    if( $('#location-map-outlet').length ){
        const init_leaflet_map = ( loc ) => {
            map.setView([loc.lat, loc.lng], 15);
            L.marker([loc.lat, loc.lng], { icon: icon }).addTo(map);
        }
        const map = L.map( 'location-map-outlet' );
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19
        }).addTo(map);
        const icon = L.icon({
            iconUrl: $('#location-map-outlet').attr( 'data-marker' ),
            iconSize: [25, 40],
        });
        const loc = { lat: $('#location-map-outlet').attr( 'data-lat' ), lng: $('#location-map-outlet').attr( 'data-lng' ) };
        init_leaflet_map( loc );
    }

    // Menu Location Switcher
    $( '.location-selector' ).on( 'change', function( e ){
        let loc_href = $(this).val();
        window.location.href = loc_href;
        e.stopPropagation();
    });

})( jQuery );